import React from 'react'
import { csx } from '@vtex/admin-ui'
import { graphql } from 'babel-plugin-relay/macro'
import { useSuspenseFragment } from 'react-relay-offline'

import type { ProductSkuImageGalleryPaginator_ProductSkuImageConnection$key } from './__generated__/ProductSkuImageGalleryPaginator_ProductSkuImageConnection.graphql'

const productSkuImageConnectionFragment = graphql`
  fragment ProductSkuImageGalleryPaginator_ProductSkuImageConnection on ProductSkuImageConnection {
    edges {
      node {
        id
        urlFullSize: url(size: 2000)
      }
    }
  }
`

export type ProductSkuImageGalleryPaginatorProps = {
  productSkuImageConnectionRef: ProductSkuImageGalleryPaginator_ProductSkuImageConnection$key
  activeImageUrl: string
}

export const ProductSkuImageGalleryPaginator = ({
  productSkuImageConnectionRef,
  activeImageUrl,
}: ProductSkuImageGalleryPaginatorProps) => {
  const productSkuImageConnection = useSuspenseFragment(
    productSkuImageConnectionFragment,
    productSkuImageConnectionRef
  )

  return (
    <div
      className={csx({
        position: 'absolute',
        bottom: '1.5rem',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      })}
    >
      {productSkuImageConnection.edges.map((productSkuImage) => (
        <div
          key={productSkuImage.node.id}
          className={csx({
            width: '2.25rem',
            height: '0.125rem',
            background:
              productSkuImage.node.urlFullSize === activeImageUrl
                ? 'black'
                : '$gray20',
            ':not(:last-child)': {
              marginRight: '$space-2',
            },
          })}
        />
      ))}
    </div>
  )
}
